import styled, {css} from "styled-components";

export const IconTitleTextTooltipContainerBox = styled.div<{showCursor: boolean}>`
    display: flex;
    align-content: center;
    align-items: center;
    ${props => props.showCursor ? css`cursor: pointer` : ''}
 `;